import { useEffect, useState } from "react";
import { API_URLS } from "../../apiUrl";
import axiosInstance from "../../components/axiosInstance";

function WardDropdown(muniCipalityId: any, borough_tbl_id: any) {
  const [wardList, setWardList] = useState<any>([]);
  const [loadingWardList, setLoadingWardList] = useState(false);
  const [isDropdownOpenWard, setIsDropdownOpenWard] = useState(false);

  const fetchWard = async () => {
    if (loadingWardList) return;
    setLoadingWardList(true);

    try {
      const { data } = await axiosInstance.post(
        API_URLS.wardBoroughWise,
        {
          municipalityTbl_id: muniCipalityId,
          borough_primary_id: borough_tbl_id,
          page: 1,
          limit: 100000,
          surveyer_id: 0,
        }
      );

      const wards = data?.data?.data || [];
      setWardList(wards);
    } catch (error) {
      console.error("Error fetching Borough", error);
    } finally {
      setLoadingWardList(false);
    }
  };

  useEffect(() => {
    if (muniCipalityId && borough_tbl_id) {
      setWardList([]);
      fetchWard();
    }
  }, [muniCipalityId, borough_tbl_id]);

  return [
    setIsDropdownOpenWard,
    isDropdownOpenWard,
    fetchWard,
    wardList,
    loadingWardList,
    setLoadingWardList,
  ];
}

export default WardDropdown;